module.exports = __webpack_public_path__ + "img/ic_option_05.fa1ff0a7.svg";